import { render, staticRenderFns } from "./addEditDialog.vue?vue&type=template&id=67090824&scoped=true"
import script from "./addEditDialog.vue?vue&type=script&lang=js"
export * from "./addEditDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67090824",
  null
  
)

export default component.exports